import citizen_contract from '../../../../build/contracts/Citizens.json'
import democracy_contract from '../../../../build/contracts/Democracy.json'
import token_contract from '../../../../build/contracts/Token.json'
import store from '../../../store'

const contract = require('truffle-contract')

export const SET_PROPOSAL = 'SET_PROPOSAL'
function proposalUpdated(proposal) {
    return {
        type: SET_PROPOSAL,
        payload: proposal
    }
}

export function getProposal(address, proposalId) {
  
    let web3 = store.getState().web3.web3Instance

    if (typeof web3 !== 'undefined') {

        return function(dispatch) {
		
            let cInstance
            let contractAddress
            let budget
            let id = 'N-N'
            let balanceInToken = 'N-N'
            let balanceIn ='N-N'
            let proposalsNum = 'N-N'
            let enoughBudget = false
            let isVoted = false
            let isDeadlineOver = false
            proposalId = parseInt(proposalId, 10)
		
            const CitizenContract = contract(citizen_contract)
            CitizenContract.setProvider(web3.currentProvider)
            const DemocracyContract = contract(democracy_contract)
            DemocracyContract.setProvider(web3.currentProvider)
            const TokenContract = contract(token_contract)
            TokenContract.setProvider(web3.currentProvider)
				
            CitizenContract.deployed().then((contractInstance) => {
                cInstance = contractInstance	
			
                return cInstance.memberId(address)
            }).then((result) => {
			
                id = result.toString()
					
                TokenContract.deployed().then((contractInstance) => {
                    cInstance = contractInstance	
				
                    return cInstance.balanceOf(address)
                }).then((result) => {
				
                    let token = parseFloat(web3.fromWei(result.toString()));
                    balanceInToken = token + " ETH"
				
                    DemocracyContract.deployed().then((contractInstance) => {
                        cInstance = contractInstance	
					
                        contractAddress = cInstance.address
					
                        return cInstance.amountRaised()
                    }).then((result) => {
				
                        budget = parseFloat(web3.fromWei(result.toString()));
                        return cInstance.balanceOf(address)
                    }).then((result) => {
					
                        let paid = parseFloat(web3.fromWei(result.toString()));
                        balanceIn = paid + " ETH"
						
                        return cInstance.checkProposalVoter(proposalId, address)
                    }).then((result) => {
					
                        isVoted = result

                        return cInstance.checkProposalDeadline(proposalId)
                    }).then((result) => {
					
                        isDeadlineOver = result

                        return cInstance.numProposals()
                    }).then((result) => {
					
                        proposalsNum = result.toString()
                        proposalsNum = parseInt(proposalsNum, 10)
					

                        if(proposalsNum < proposalId){

                            return dispatch(proposalUpdated({'memberId':id,'balanceInToken':balanceInToken,'balanceIn':balanceIn,'proposalsNum':proposalsNum,
								'enoughBudget':enoughBudget,'recipient':'N-N','amount':'N-N','description':'N-N','voteYes':'N-N',
								'voteNo':'N-N','allVotes':'N-N','minimumVotes':'N-N','isExecuted':false,'isDeadlineOver':true,'deadline':'N-N',
								'proposalId':'N-N','isVoted':isVoted}))
                        } else {

                            cInstance.proposals(proposalId).then((result) => {
					
                                let amount = parseFloat(web3.fromWei(result[5].toString()));
                                if(budget < amount){
                                    enoughBudget = false
                                } else {
                                    enoughBudget = true
                                }
		
                                let amountEth = amount + " ETH"
							
                                let recipient = result[0].toString();
                                if(recipient === contractAddress){
                                    recipient = 'No recipient'
                                }
		
                                return dispatch(proposalUpdated({'memberId':id,'balanceInToken':balanceInToken,'balanceIn':balanceIn,'proposalsNum':proposalsNum,
									'enoughBudget':enoughBudget,'recipient':recipient,'amount':amountEth,'description':result[2].toString(),'voteYes':result[8].toString(),
									'voteNo':result[9].toString(),'allVotes':result[6].toString(),'minimumVotes':result[7].toString(),'isExecuted':result[1],'deadline':result[4].toString(),
									'isDeadlineOver':isDeadlineOver,'proposalId':proposalId.toString(),'isVoted':isVoted}))
                            })
                        }
					
                    })
				
                })
			
            })
		
        }
    } else {
        console.error('Web3 is not initialized.');
    }
}



// WEBPACK FOOTER //
// ./src/user/actions/proposal/GetProposal.js